
import React from 'react';
import { useTranslation } from 'react-i18next';
import { User, Code, Heart, Milk } from 'lucide-react';

const About: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-24 bg-[#FAFAFA]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-gray-100">
          <div className="flex flex-col items-center text-center space-y-6">
            <div className="inline-flex items-center justify-center p-4 bg-indigo-50 text-[#0F172A] rounded-full">
              <User className="w-8 h-8" />
            </div>
            <h2 className="text-3xl font-bold text-[#0F172A]">{t('about.title')}</h2>
            <p className="text-lg text-[#1E293B]/70 leading-loose max-w-2xl">
              {t('about.content')}
            </p>
            <div className="flex flex-col items-center space-y-6 pt-4">
              <div className="flex space-x-6">
                <div className="flex flex-col items-center space-y-2">
                  <div className="p-3 bg-gray-50 rounded-lg">
                    <Code className="w-5 h-5 text-gray-400" />
                  </div>
                  <span className="text-xs font-medium text-gray-500 uppercase tracking-widest">Tech</span>
                </div>
                <div className="flex flex-col items-center space-y-2">
                  <div className="p-3 bg-gray-50 rounded-lg">
                    <Heart className="w-5 h-5 text-gray-400" />
                  </div>
                  <span className="text-xs font-medium text-gray-500 uppercase tracking-widest">Mission</span>
                </div>
              </div>

              {/* Subtle Support Link */}
              <a 
                href="https://buymeacoffee.com/rtneg" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group flex items-center space-x-2 text-sm text-gray-400 hover:text-[#3B82F6] transition-colors pt-4"
              >
                <Milk className="w-4 h-4" />
                <span className="border-b border-transparent group-hover:border-[#3B82F6]">{t('about.support')}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
